function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#FFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.5 108.5h123v11H7.5zM.5.5h137v108H.5z"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  d: "M100.429 14.5h11.142m-11.142 4h11.142m-11.142 4h11.142m-11.142 4h11.142m-11.142 4h11.142m-11.142 4h11.142m-29.142-20H93.57m-11.142 4H93.57m-11.142 4H93.57m-11.142 4H93.57m-11.142 4H93.57m-11.142 4H93.57m6.858 4h11.142m-29.142-.1H93.57m6.858 7.1h11.142m-11.142 4h11.142m-11.142 4h11.142m-11.142 4h11.142m-11.142 4h11.142m-11.142 4h11.142m-29.142-20H93.57m-11.142 4H93.57m-11.142 4H93.57m-11.142 4H93.57m-11.142 4H93.57m-11.142 4H93.57m6.858 4h11.142m-29.142-.1H93.57m6.858 7.1h11.142m-11.142 4h11.142m-11.142 4h11.142m-11.142 4h11.142m-11.142 4h11.142m-11.142 4h11.142m-29.142-20H93.57m-11.142 4H93.57m-11.142 4H93.57m-11.142 4H93.57m-11.142 4H93.57m-11.142 4H93.57m6.858 4h11.142m-29.142-.1H93.57m24.858-85.9h11.142m-11.142 4h11.142m-11.142 4h11.142m-11.142 4h11.142m-11.142 4h11.142m-11.142 4h11.142m-11.142 3.9h11.142m-11.142 7.1h11.142m-11.142 4h11.142m-11.142 4h11.142m-11.142 4h11.142m-11.142 4h11.142m-11.142 4h11.142m-11.142 3.9h11.142m-11.142 7.1h11.142m-11.142 4h11.142m-11.142 4h11.142m-11.142 4h11.142m-11.142 4h11.142m-11.142 4h11.142m-11.142 3.9h11.142"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.5 21.5h47v71h-47z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 12,
  height: 10,
  x: 49.5,
  y: 55.5,
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  d: "M49.5 58.5h12"
}));

function SvgRoomGenerator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 138,
    height: 120,
    viewBox: "0 0 138 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomGenerator);
export default __webpack_public_path__ + "static/media/RoomGenerator.8ab41c33.svg";
export { ForwardRef as ReactComponent };